<script>
  export default {
    name: 'RecursiveSection',
    props: {
      section: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<template>
  <component :is="section.component || 'div'" v-bind="section.bind">
    <template v-if="section.children">
      <span v-if="section.text" v-html="section.text" />

      <RecursiveSection
        v-for="(section_child, i) in section.children"
        :section="section_child"
        :key="section_child.text || section_child.component + i"
      />
    </template>
    <span v-else v-html="section.text" />
  </component>
</template>

<style scoped lang="scss"></style>
